/**
 * Coarse device class from a tracking pixel User-Agent (email clients often omit or simplify UA).
 */
export function getDeviceKindFromUserAgent(
  ua: string | undefined | null
): "mobile" | "desktop" | null {
  if (!ua || !ua.trim()) return null;
  const s = ua.trim();

  if (
    /iphone|ipod|windows phone|iemobile|blackberry|bb10|webos|opera mini|wpdesktop|fennec/i.test(s)
  ) {
    return "mobile";
  }
  if (/android/i.test(s) && /mobile/i.test(s)) {
    return "mobile";
  }
  if (/\bmobi\b/i.test(s) && !/ipad/i.test(s)) {
    return "mobile";
  }

  if (/ipad|tablet|playbook|kindle|silk\b/i.test(s)) {
    return "desktop";
  }
  if (/android/i.test(s)) {
    return "desktop";
  }

  return "desktop";
}
